import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { WsUiModule } from "@web/util/ws-ui/ws-ui.module";
import { AiAgentMarkdownModule } from "@web/app/pipes/ai-agent-markdown/ai-agent-markdown.module";
import { DwsPermissionDirectiveModule } from "@util/directives/dwsPermission/dws-permission.module";
import { AiAgentPanelComponent } from "./ai-agent-panel.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MatProgressSpinnerModule,
    WsUiModule,
    AiAgentMarkdownModule,
    DwsPermissionDirectiveModule,
  ],
  declarations: [AiAgentPanelComponent],
  exports: [AiAgentPanelComponent],
})
export class AiAgentPanelModule {}
